import React from "react";
import {
  Box,
  ButtonGroup,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import UndoIcon from "@mui/icons-material/Undo";
import GradientCard from "./gradients/GradientCard";
import { useData } from "../providers/DataProvider";

const StyledWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "10px",
}));

const StyledVariantImageToggleButton = styled(ToggleButton)(({ theme }) => ({
  background: "transparent !important",
  border: "none",
  padding: "0px",
  marginBottom: "10px",
  display: "block",
}));

const StyledVariantImageBox = styled(Box)(({ theme }) => ({
  width: "75px",
  height: "75px",
  [theme.breakpoints.up("laptop")]: {
    width: "100px",
    height: "100px",
  },
}));

function CustomizerToolbar({ canvasImage, handleToolbarChange, orderPreviewMode }) {
  const data = useData();

  return (
    <StyledWrapper>
      <ButtonGroup orientation="vertical">
        <IconButton onClick={() => handleToolbarChange("zoomIn")}>
          <ZoomInIcon />
        </IconButton>
        <IconButton onClick={() => handleToolbarChange("zoomOut")}>
          <ZoomOutIcon />
        </IconButton>
        {!orderPreviewMode && (
          <IconButton onClick={() => handleToolbarChange("undo")}>
            <UndoIcon />
          </IconButton>
        )}
      </ButtonGroup>
      <ToggleButtonGroup
        exclusive
        orientation="vertical"
        value={canvasImage?.view}
        onChange={(event, value) => handleToolbarChange(value)}
        sx={{ alignItems: "center" }}
      >
        {data.variant.images.map((image, index) => (
          <StyledVariantImageToggleButton key={index} value={image.view}>
            <StyledVariantImageBox>
              <GradientCard variant="square" selected={image.view === canvasImage?.view}>
                <Typography variant="h4" sx={{ textTransform: "capitalize" }}>
                  {image.view}
                </Typography>
                <Box
                  sx={{
                    flex: "1",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={image.thumbnail}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                    }}
                  />
                </Box>
              </GradientCard>
            </StyledVariantImageBox>
          </StyledVariantImageToggleButton>
        ))}
      </ToggleButtonGroup>
    </StyledWrapper>
  );
}

export default React.memo(CustomizerToolbar);
